import { useCallback, useEffect, useRef, useState } from 'react'

import { QueryClient, useQueryClient } from '@tanstack/react-query'

import { UserTheme } from '@utils/theme'

export type UseUserTheme = () => UserTheme

type GetUserTheme = (queryClient: QueryClient) => UserTheme

const getUserTheme: GetUserTheme = (queryClient) =>
  queryClient.getQueryData<UserTheme>(['theme', 'user']) as UserTheme

const useUserTheme: UseUserTheme = () => {
  const queryClient = useQueryClient()
  const queryCache = queryClient.getQueryCache()
  const unsubscribeFnRef = useRef<() => void>(undefined)

  const [userTheme, setUserTheme] = useState<UserTheme>(() =>
    getUserTheme(queryClient),
  )

  const updateType = useCallback(
    (args: any) => {
      if (
        ['invalidate'].includes(args?.action?.type) &&
        args.query.queryKey[0] === 'theme' &&
        args.query.queryKey[1] === 'user'
      ) {
        setUserTheme(getUserTheme(queryClient))
      }
    },
    [queryClient],
  )

  useEffect(() => {
    setUserTheme(getUserTheme(queryClient))

    unsubscribeFnRef.current = queryCache.subscribe(updateType)

    return () => {
      if (unsubscribeFnRef.current) {
        unsubscribeFnRef.current()
      }
    }
  }, [queryCache, queryClient, updateType])

  return userTheme
}

export { getUserTheme }

export default useUserTheme
